module.exports = __webpack_public_path__ + "static/media/emojis_21.2c48c5bf.svg";